export const getReportVersions = state => state.reports.list
export const getReports = state => state.reports.reports
export const getReportTypes = state => state.reports.reportTypes
export const getPublishedVersion = state => state.reports.publishedReportVersion